import React from "react";
import { DEPARTMENTS, formatDateTime } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { UserCheck, Circle } from "lucide-react";

export const DeptPicPanel = ({ job }) => {
  const pics = job.dept_pics || {};
  return (
    <Card className="p-5" data-testid="dept-pic-panel">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-display font-bold flex items-center gap-2"><UserCheck className="w-4 h-4" /> PIC by Department</h3>
        {job.current_pic_name && <Badge className="bg-cyan-600" data-testid="current-pic-badge">Current: {job.current_pic_name}</Badge>}
      </div>
      <p className="text-xs text-muted-foreground mb-3">PIC name is recorded automatically from the staff member who last updated the status in each department.</p>
      <div className="space-y-2">
        {DEPARTMENTS.map((d) => {
          const p = pics[d.key];
          const active = job.current_dept === d.key;
          return (
            <div key={d.key} className={`flex items-start gap-3 p-2 rounded-md border ${active ? "border-cyan-400 bg-cyan-50 dark:bg-cyan-950/30" : "border-transparent"}`} data-testid={`dept-pic-${d.key}`}>
              <Circle className={`w-3 h-3 mt-1 shrink-0 ${p ? "fill-emerald-500 text-emerald-500" : "text-muted-foreground/40"}`} />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold">{d.label}</div>
                {p ? (
                  <div className="text-xs text-muted-foreground truncate">{p.name} • {p.status} • {formatDateTime(p.at)}</div>
                ) : (
                  <div className="text-xs text-muted-foreground/60">No update yet</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};
